import SearchBar, { SearchBarOptions } from '@/components/UiElements/SearchBar'

type ThemeSearchProps = {
    onSearch: (value: string) => void
    onOrderChange: () => void
}

const ThemeSearch = ({
                           onSearch,
                           onOrderChange,
                       }: ThemeSearchProps) => {
    const options: SearchBarOptions[] = [
        {
            label: <span className="font-icon-solid"></span>,
            onClick: onOrderChange,
            className: 'w-[50px] !px-0',
        },
    ];

    return (
        <SearchBar
            placeholder="Search by theme..."
            onChange={onSearch}
            options={options}
        />
    )
}

export default ThemeSearch
